import { Button, Card, ControlGroup, H3, InputGroup, Intent } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import { useEffect, useState } from "react";

const styles = {
	container: css({ width: "100%" }),
	card: css({ padding: "20px", width: "400px", margin: "0 auto", textAlign: "left" }),
	button: css({ height: "30px" }),
};

interface Props {
	onSuccessfulLogin: (res: any) => void;
	login: (password: string) => any;
	title: string;
}
const Login: React.FC<Props> = ({ onSuccessfulLogin, login, title }) => {
	const [password, setPassword] = useState("");
	const [unsuccessfulLogin, setUnsuccessfulLogin] = useState(false);

	useEffect(() => {
		setUnsuccessfulLogin(false);
	}, [password]);

	const tryLogin = async () => {
		const res = await login(password);
		if (res.success) {
			setUnsuccessfulLogin(false);
			onSuccessfulLogin(res);
		} else {
			setUnsuccessfulLogin(true);
		}
	};
	return (
		<div {...styles.container}>
			<Card {...styles.card}>
				<H3>Login to {title}</H3>
				<form>
					<ControlGroup>
						<InputGroup
							placeholder="password"
							value={password}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
							intent={unsuccessfulLogin ? Intent.DANGER : Intent.NONE}
							type="password"
						/>
						<Button onClick={tryLogin} type="submit" {...styles.button}>
							Submit
						</Button>
					</ControlGroup>
				</form>
			</Card>
		</div>
	);
};

export default Login;



// WEBPACK FOOTER //
// ./src/Backend/Login.tsx